import {selectPendingBuildings} from "../../../redux/reducers/sharedStateReducer/selectors";
import {validateCurrentPlayerPendingBuildings} from "../../gameState/construction/pendingBuildingsValidation";
import {findConstructionUndoConflict} from "../../gameState/construction/findConstructionUndoConflict";
import {createUndoConstructionAction} from "../../gameState/construction/createUndoConstructionAction";

// Зафиксированное действие (разведка шахты гномами) не отменяется ничем
const selectUndoableBuildings = (state) => selectPendingBuildings(state).filter((building) => !building.isCommited);

// Действие, которое можно снять, не оторвав более поздние: само действие, если
// ни одно более позднее без него не встало бы, иначе — зависящее от него (и так
// вглубь). Цепочка конечна: зависимое всегда позже, а от последнего действия
// хода не зависит ничего
const findUndoWithoutDependents = (state, building) => {
  let candidate = building;
  let conflict = findConstructionUndoConflict(state, candidate);
  while (conflict) {
    candidate = conflict.building;
    conflict = findConstructionUndoConflict(state, candidate);
  }
  return candidate;
};

/**
 * Отменяет невалидные pending-строения перед завершением фазы,
 * чтобы валидация не заблокировала завершение хода (страховка,
 * зеркалит серверный авто-откат). НЕ вызывается после каждого действия:
 * по правилам игры валидация происходит только в конце хода.
 *
 * Снимается последнее невалидное строение, но не раньше тех, что встали только
 * благодаря ему. Проверка при завершении хода связность с городом не смотрит
 * (дороги не проверяет вовсе): дорога или центральный квартал, поставленные
 * через невалидную ферму, остались бы на поле оторванными. Зависимость — та же,
 * что у отмены двойным кликом (findConstructionUndoConflict). Более поздние
 * действия, которым отменяемое не нужно, остаются.
 *
 * Сервер, закрывая ход за человека, снимает невалидное по тому же принципу,
 * но своим планировщиком (rollbackInvalidPendingBuildings): тот считает план
 * целиком до первой отмены и сверяет его с редьюсерами.
 */
export const sanitizeInvalidPendingBuildings = (store) => {
  let state = store.getState();
  let undoableBuildings = selectUndoableBuildings(state);
  let previousUndoableCount = Infinity;

  // Каждый шаг снимает одно действие; если редьюсер отмену не принял — выходим
  while (undoableBuildings.length > 0 && undoableBuildings.length < previousUndoableCount) {
    const validationResult = validateCurrentPlayerPendingBuildings(state);
    if (validationResult.isValid) {
      return;
    }

    const invalidHexKeys = new Set(validationResult.invalidBuildings.map((building) => building.hexKey));
    // Последнее действие в ячейке: действия одной ячейки лежат друг на друге
    // (крепость на квартале этого хода снимается раньше квартала)
    const lastInvalid = undoableBuildings.findLast((building) => invalidHexKeys.has(building.hexKey));
    // Невалидно только зафиксированное — снимаем с конца, вдруг мешает более позднее
    const buildingToUndo = lastInvalid
      ? findUndoWithoutDependents(state, lastInvalid)
      : undoableBuildings[undoableBuildings.length - 1];

    store.dispatch(createUndoConstructionAction(buildingToUndo));

    previousUndoableCount = undoableBuildings.length;
    state = store.getState();
    undoableBuildings = selectUndoableBuildings(state);
  }
};
